<template>
  <div class="offer-categories-list">
    <!-- List (for larger screens) -->
    <NuxtLink
      :to="
        localePath({
          name: 'offers',
        })
      "
      class="offer-category-heading-link"
    >
      {{ $t("offers.popular-offers") }}
    </NuxtLink>

    <NuxtLink
      v-for="category in data?.offerCategories"
      :key="category.id"
      :to="
        localePath({
          name: 'offers-slug',
          params: { slug: category.slug },
        })
      "
      class="offer-category-link hide-small"
      :class="{ active: offerCategory === category.slug }"
    >
      {{ category.name }}</NuxtLink
    >

    <!-- Select list (for smaller screens) -->
    <BaseSelect
      :model-value="offerCategory"
      @update:modelValue="onSelectCategory"
      class="category-select select-secondary hide-medium-up"
    >
      <option value="">
        {{ $t("offers.select-placeholders") }}
      </option>
      <option
        v-for="category in data?.offerCategories"
        :key="category.id"
        :value="category.slug"
        :selected="category.slug === offerCategory"
      >
        {{ category.name }}
      </option>
    </BaseSelect>
  </div>
</template>

<script setup lang="ts">
import { useRouteParams } from "@vueuse/router";
import { useOfferCategoryQuery } from "~/graphql/generated";

const localePath = useLocalePath();
const router = useRouter();

const offerCategory = useRouteParams("slug", "", {
  transform: String,
});

const { data } = await useOfferCategoryQuery({
  variables: {
    pagination: {
      limit: 500,
      offset: 0,
    },
  },
});

/** Handler for navigating when selecting an offer through the mobile selection. */
function onSelectCategory(slug: string) {
  const to = localePath({ name: "offers-slug", params: { slug } });
  router.push(to);
}
</script>

<style lang="scss" scoped>
.offer-categories-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.offer-category-link {
  line-height: 1.5rem;
}

.active {
  color: var(--primary);
}

.category-select {
  width: 100%;
}

.offer-category-heading-link {
  font-size: 1.125rem;
  font-weight: 600;
}
</style>
